export const sources={};export const img={src:"__VITE_ASSET__bLNX6U6f8qE7L2W0pHPLmA__",w:640,h:640};export default{sources:sources,img:img};